import { Spin } from "antd";
import { Card, Col } from "reactstrap";
import BugsReportedHeader from "./BugsReportedHeader";
import BugsReportedBody from "./BugsReportedBody";

const BugsReported = ({ bugs, loading }) => {

  return (
    <Col xl="6" className="proorder box-col-40 mb-5">
      <Card className="user-chat mb-5 relative">
        {loading && <div className={`charts-initial-loading`}><Spin /></div>}
        <BugsReportedHeader />
        <BugsReportedBody bugs={bugs} />
      </Card>
    </Col>
  );
};

export default BugsReported;
